import { render, staticRenderFns } from "./ToothRemoveButtons.vue?vue&type=template&id=0d9d1c90&scoped=true&"
import script from "./ToothRemoveButtons.vue?vue&type=script&lang=js&"
export * from "./ToothRemoveButtons.vue?vue&type=script&lang=js&"
import style0 from "./ToothRemoveButtons.vue?vue&type=style&index=0&id=0d9d1c90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9d1c90",
  null
  
)

export default component.exports